<template>
  <div v-if="show" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4>Edit Item</h4>
        <span class="close" @click="$emit('close')">&times;</span>
      </div>
      <div class="dropdown-container-modal">
        <div class="dropdown-item">
          <label for="edit-item-select">Item Name</label>
          <select id="edit-item-select" v-model="localItemName" disabled>
            <option v-for="item in items" :key="item.id" :value="item.id">{{ item.item_name }}</option>
          </select>
        </div>
      </div>
      <div class="dropdown-container-modal">
        <div class="dropdown-item">
          <label for="edit-quantity-input">Item Quantity</label>
          <input type="number" id="edit-quantity-input" v-model="localQuantity" min="0" />
        </div>
      </div>
      <button type="button" class="btn btn-success mt-4" @click="updateItem">Update</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    itemName: String,
    quantity: Number,
    items: Array
  },
  data() {
    return {
      localItemName: this.itemName,
      localQuantity: this.quantity
    };
  },
  watch: {
    itemName(newVal) {
      this.localItemName = newVal;
    },
    quantity(newVal) {
      this.localQuantity = newVal;
    }
  },
  methods: {
    updateItem() {
      this.$emit('update', { item_id: this.localItemName, quantity: this.localQuantity });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pages/modal/modal.scss';
</style>